// @core/api/endpoints/task/list_views.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListViewsResponse,
} from '../../../types/task';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/task';

/**
 * List views
 * Returns available task views including personal views and shared team views. Views provide quick access to filtered task lists.
 */
export async function ListViews(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListViewsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/task-views`;
  const requestOptions = options;
  return client.get<ListViewsResponse>(requestPath, { ...requestOptions, params });
}
